module.exports = __webpack_public_path__ + "img/mangopay-call-error.f3b2166a.png";